import { ETables } from '../types/enums/ETables';
import { AlertProps } from '@material-ui/lab/Alert';

const tPaths = {
  global: {
    ok: 'global.ok',
    cancel: 'global.cancel',
    yes: 'global.yes',
    no: 'global.no',
    delete: 'global.delete',
    yesNo: (bool: boolean) => (bool ? 'global.yes' : 'global.no'),
    goBack: 'global.goBack',
    wentWrong: 'global.wentWrong',
    nonAppEmailEmailVerification: 'global.nonAppEmailEmailVerification',
    termsOfUse: 'global.termsOfUse',
    download: 'global.download',
  },
  sideMenu: {
    dashboard: 'sideMenu.dashboard',
    packages: 'sideMenu.packages',
    promoCampaigns: 'sideMenu.promoCampaigns',
    experiences: 'sideMenu.experiences',
    places: 'sideMenu.places',
    countries: 'sideMenu.countries',
    cities: 'sideMenu.cities',
    athletes: 'sideMenu.athletes',
    disciplines: 'sideMenu.disciplines',
    hotSpots: 'sideMenu.hotSpots',
    events: 'sideMenu.events',
    destinations: 'sideMenu.destinations',
    vouchers: 'sideMenu.vouchers',
    customers: 'sideMenu.customers',
    systemUsers: 'sideMenu.systemUsers',
    calculator: 'sideMenu.calculator',
    notifications: 'sideMenu.notifications',
    carrierStatus: 'sideMenu.carrierStatus',
    legalLinks: 'sideMenu.legalLinks',
    promoCodes: 'sideMenu.promoCodes',
    partnerCodes: 'sideMenu.partnerCodes',
    purchaseReceiptNotification: 'sideMenu.purchaseReceiptNotification',
    verifyEmailNotification: 'sideMenu.verifyEmailNotification',
    resetPasswordNotification: 'sideMenu.resetPasswordNotification',
    confirmationSupport: 'sideMenu.confirmationSupport',
    settings: 'sideMenu.settings',
    inAppNotifications: 'sideMenu.inAppNotifications',
    cruiseLines: 'sideMenu.cruiseLines',
    allShips: 'sideMenu.allShips',
    allCruiseLines: 'sideMenu.allCruiseLines',
  },
  header: {
    myProfile: 'header.myProfile',
    logOut: 'header.logOut',
  },
  columnsNames: {
    insertedCount: 'columnsNames.insertedCount',
    usedCount: 'columnsNames.usedCount',
    carrierBundle: 'columnsNames.carrierBundle',
    country: 'columnsNames.country',
    dataAmount: 'columnsNames.dataAmount',
    lastEditDate: 'columnsNames.lastEditDate',
    origin: 'columnsNames.origin',
    price: 'columnsNames.price',
    region: 'columnsNames.region',
    status: 'columnsNames.status',
    title: 'columnsNames.title',
    iso: 'columnsNames.iso',
    city: 'columnsNames.city',
    athlete: 'columnsNames.athlete',
    featured: 'columnsNames.featured',
    dateOfBirth: 'columnsNames.dateOfBirth',
    email: 'columnsNames.email',
    hasESim: 'columnsNames.hasESim',
    nameSurname: 'columnsNames.nameSurname',
    rbmNumber: 'columnsNames.rbmNumber',
    referralCode: 'columnsNames.referralCode',
    registrationDate: 'columnsNames.registrationDate',
    esimNumber: 'columnsNames.esimNumber',
    userId: 'columnsNames.userId',
    phone: 'columnsNames.phone',
    totalData: 'columnsNames.totalData',
    usedData: 'columnsNames.usedData',
    destination: 'columnsNames.destination',
    activationDate: 'columnsNames.activationDate',
    validUntil: 'columnsNames.validUntil',
    autoRenewing: 'columnsNames.autoRenewing',
    variations: 'columnsNames.variations',
    name: 'columnsNames.name',
    id: 'columnsNames.id',
    _id: 'columnsNames.id',
    carrierSubscriberReference: 'columnsNames.carrierSubscriberReference',
    delete: 'columnsNames.delete',
    code: 'columnsNames.code',
    assignedTo: 'columnsNames.assignedTo',
    activity: 'columnsNames.activity',
    heavy: 'columnsNames.heavy',
    moderate: 'columnsNames.moderate',
    rare: 'columnsNames.rare',
    group: 'columnsNames.group',
    visible: 'columnsNames.visible',
    marketingName: 'columnsNames.marketingName',
    label: 'columnsNames.label',
    image: 'columnsNames.image',
    jsxCheckbox: 'columnsNames.jsxCheckbox',
    reservedBy: 'columnsNames.reservedBy',
    createdAt: 'columnsNames.createdAt',
    commercialCode: 'columnsNames.commercialCode',
    technicalCode: 'columnsNames.technicalCode',
    customersCountWhoInstalledApp: 'columnsNames.customersCountWhoInstalledApp',
    partnerCampaign: 'columnsNames.partnerCampaign',
    rewardType: 'columnsNames.rewardType',
    rewardThreshold: 'columnsNames.rewardThreshold',
    totalPrice: 'columnsNames.totalPrice',
    body: 'columnsNames.body',
    action: 'columnsNames.action',
    internalName: 'columnsNames.internalName',
    publicCode: 'columnsNames.publicCode',
    type: 'columnsNames.type',
    codeType: 'columnsNames.codeType',
    targetPackage: 'columnsNames.targetPackage',
    generatedCodeCount: 'columnsNames.generatedCodeCount',
    insertedCodeCount: 'columnsNames.insertedCodeCount',
    usedCodeCount: 'columnsNames.usedCodeCount',
    cruiseLines: 'columnsNames.cruiseLines',
    sailingTo: 'columnsNames.sailingTo',
    packages: 'columnsNames.packages',
    shipsCount: 'columnsNames.shipsCount',
    edited: 'columnsNames.edited',
  },
  tablePaging: {
    noRecords: 'tablePaging.noRecords',
    of: 'tablePaging.of',
    page: 'tablePaging.page',
    prevPage: 'tablePaging.prevPage',
    firstPage: 'tablePaging.firstPage',
    nextPage: 'tablePaging.nextPage',
    lastPage: 'tablePaging.lastPage',
  },
  itemContent: {
    edit: 'itemContent.edit',
    active: 'itemContent.active',
    save: 'itemContent.save',
    back: 'itemContent.back',
    add: 'itemContent.add',
    editPackage: 'itemContent.editPackage',
    viewCustomer: 'itemContent.viewCustomer',
    addCustomer: 'itemContent.addCustomer',
    editSystemUser: 'itemContent.editSystemUser',
    addSystemUser: 'itemContent.addSystemUser',
    addPromoCampaign: 'itemContent.addPromoCampaign',
    editPromoCampaign: 'itemContent.editPromoCampaign',
    editCruiseShip: 'itemContent.editCruiseShip',
    addCruiseShip: 'itemContent.addCruiseShip',
    editCruiseLine: 'itemContent.editCruiseLine',
    addCruiseLine: 'itemContent.addCruiseLine',
    successOnRemoveSystemUser: 'itemContent.successOnRemoveSystemUser',
    errorOnRemoveSystemUser: 'itemContent.errorOnRemoveSystemUser',
    viewCarrierStatus: 'itemContent.viewCarrierStatus',
    editEmailTemplate: 'itemContent.editEmailTemplate',
    editLinks: 'itemContent.editLinks',
    successOnEdit: 'itemContent.successOnEdit',
    successOnAdd: 'itemContent.successOnAdd',
    removeCustomer: 'itemContent.deleteCustomer',
    succesOnRemoveCustomer: 'itemContent.succesOnRemoveCustomer',
    errorOnRemoveCustomer: 'itemContent.errorOnRemoveCustomer',
    carrierApiStatus: 'itemContent.carrierApiStatus',
    dataCalculator: 'itemContent.dataCalculator',
    addActivity: 'itemContent.addActivity',
    editActivity: 'itemContent.editActivity',
    purchaseReceipt: 'itemContent.purchaseReceipt',
    downloadPdf: 'itemContent.downloadPdf',
    deactivatePlan: 'itemContent.deactivatePlan',
    disableAutorenewing: 'itemContent.disableAutorenewing',
    renewing: 'itemContent.renewing',
    renewingDisabled: 'itemContent.renewingDisabled',
    editAppVersions: 'itemContent.editAppVersions',
    supportReasons: 'itemContent.supportReasons',
    resetAccounts: 'itemContent.resetAccounts',
    resetEsimsHistory: 'itemContent.resetEsimsHistory',
    addPartnerCode: 'itemContent.addPartnerCode',
    addNotification: 'itemContent.addNotification',
    resetPartnercodes: 'itemContent.resetPartnercodes',
  },
  editFormLabels: {
    targetPlan: 'editFormLabels.targetPlan',
    durationValidity: (months: number) => 'editFormLabels.' + (months > 1 ? 'months' : 'month'),
    title: 'editFormLabels.title',
    description: 'editFormLabels.description',
    packageIntro: 'editFormLabels.packageIntro',
    packageConfirmation: 'editFormLabels.packageConfirmation',
    image: 'editFormLabels.image',
    videoHeadline: 'editFormLabels.videoHeadline',
    url: 'editFormLabels.url',
    country: 'editFormLabels.country',
    carrierBundle: 'editFormLabels.carrierBundle',
    lastEditDate: 'editFormLabels.lastEditDate',
    origin: 'editFormLabels.origin',
    price: 'editFormLabels.price',
    region: 'editFormLabels.region',
    validity: 'editFormLabels.validity',
    nameSurname: 'editFormLabels.nameSurname',
    name: 'editFormLabels.name',
    surname: 'editFormLabels.surname',
    phone: 'editFormLabels.phone',
    email: 'editFormLabels.email',
    modules: 'editFormLabels.modules',
    password: 'editFormLabels.password',
    athlete: 'editFormLabels.athlete',
    subject: 'editFormLabels.subject',
    content: 'editFormLabels.content',
    oldPassword: 'editFormLabels.oldPassword',
    newPassword: 'editFormLabels.newPassword',
    confirmPassword: 'editFormLabels.confirmPassword',
    status: 'editFormLabels.status',
    variation: 'editFormLabels.variation',
    id: 'editFormLabels.id',
    _id: 'editFormLabels.id',
    carrierSubscriberReference: 'editFormLabels.carrierSubscriberReference',
    emailVerified: 'editFormLabels.emailVerified',
    esimNumber: 'editFormLabels.esimNumber',
    autoRenewing: 'editFormLabels.autoRenewing',
    displayName: 'editFormLabels.displayName',
    heavy: 'editFormLabels.heavy',
    moderate: 'editFormLabels.moderate',
    rare: 'editFormLabels.rare',
    activityName: 'editFormLabels.activityName',
    registrationDate: 'editFormLabels.registrationDate',
    promocodeGroups: 'editFormLabels.promocodeGroups',
    packageType: 'editFormLabels.packageType',
    visibleInMainList: 'editFormLabels.visibleInMainList',
    esimActivationAllowed: 'editFormLabels.esimActivationAllowed',
    fcmToken: 'editFormLabels.fcmToken',
    android: 'editFormLabels.android',
    ios: 'editFormLabels.ios',
    commercialCode: 'editFormLabels.commercialCode',
    partnerCampaign: 'editFormLabels.partnerCampaign',
    rewardType: 'editFormLabels.rewardType',
    rewardThresholdInMB: 'editFormLabels.rewardThresholdInMB',
    balance: 'editFormLabels.balance',
    referralCode: 'editFormLabels.referralCode',
    usedReferralCode: 'editFormLabels.usedReferralCode',
    technicalCode: 'editFormLabels.technicalCode',
    affiliateCode: 'editFormLabels.affiliateCode',
    body: 'editFormLabels.body',
    iosDeepLink: 'editFormLabels.iosDeepLink',
    androidDeepLink: 'editFormLabels.androidDeepLink',
    internalName: 'editFormLabels.internalName',
    genericUniqueCode: 'editFormLabels.genericUniqueCode',
    publicCode: 'editFormLabels.publicCode',
    campaignType: 'editFormLabels.campaignType',
    package: 'editFormLabels.package',
    oncePerDevice: 'editFormLabels.oncePerDevice',
    oncePerUser: 'editFormLabels.oncePerUser',
    promoCodePrefix: 'editFormLabels.promoCodePrefix',
    quantityOfCodes: 'editFormLabels.quantityOfCodes',
    prefersTitleHidden: 'editFormLabels.prefersTitleHidden',
    shipName: 'editFormLabels.shipName',
    addCruiseLine: 'editFormLabels.addCruiseLine',
    cruiseLine: 'editFormLabels.cruiseLine',
    plans: 'editFormLabels.plans',
  },
  editFormTabs: {
    settings: 'editFormTabs.settings',
  },
  dropzone: {
    dropHere: 'dropzone.dropHere',
    uploadImage: 'dropzone.uploadImage',
    tooLarge: 'dropzone.tooLarge',
    tooMany: 'dropzone.tooMany',
    wrongFormat: 'dropzone.wrongFormat',
  },
  imageUpload: {
    upload: 'imageUpload.upload',
    pasteUrl: 'imageUpload.pasteUrl',
    image: 'imageUpload.image',
    changeImage: 'imageUpload.changeImage',
  },
  tableGenerateCodes: {
    title: 'tableGenerateCodes.title',
    howMany: 'tableGenerateCodes.howMany',
    selectGroup: 'tableGenerateCodes.selectGroup',
    generateButton: 'tableGenerateCodes.generateButton',
    successOnAdd: 'tableGenerateCodes.successOnAdd',
    showInAdminPanel: 'tableGenerateCodes.showInAdminPanel',
  },
  table: {
    table: (table: ETables) => `table.${table}`,
    total: 'table.total',
    downloadXls: 'table.downloadXls',
    refresh: 'table.refresh',
    add: 'table.add',
    addShip: 'table.addShip',
    addCruiseLine: 'table.addCruiseLine',
    successOnDeactivate: 'table.successOnDeactivate',
    successOnDeactivateCruiseLine: 'table.successOnDeactivateCruiseLine',
    search: 'table.search',
    searchWarning: 'table.searchWarning',
    deleteAsk: 'table.deleteAsk',
    noSearchFound: 'table.noSearchFound',
    activationCodes: 'table.activationCodes',
    generateCodes: 'table.generateCodes',
    resetEsims: 'table.resetEsims',
    successOnRemoveEsims: 'table.successOnRemoveEsims',
    notSelectedUsers: 'table.notSelectedUsers',
    noOneEsim: 'table.noOneEsim',
    all: 'table.all',
    filter: 'table.filter',
    notFound: 'table.notFound',
    fromTo: (isFrom: boolean) => (isFrom ? 'table.from' : 'table.to'),
    activateSelected: 'table.activateSelected',
    deactivateSelected: 'table.deactivateSelected',
    activate: 'table.activate',
    deactivate: 'table.deactivate',
    activateCampaign: 'table.activateCampaign',
    deactivateCampaign: 'table.deactivateCampaign',
    reservePromocode: 'table.reservePromocode',
    unreservePromocode: 'table.unreservePromocode',
    downloadAbusedPlans: 'table.downloadAbusedPlans',
    analyticsHistory: 'table.analyticsHistory',
    send: 'table.send',
  },
  reportGenerator: {
    generate: 'reportGenerator.generate',
    types: 'reportGenerator.types',
    selectReportType: 'reportGenerator.selectReportType',
    purchasedPackages: 'reportGenerator.purchasedPackages',
  },
  systemUsers: {
    view: 'systemUsers.view',
    edit: 'systemUsers.edit',
  },
  promoCampaigns: {
    view: 'promoCampaigns.view',
    edit: 'promoCampaigns.edit',
  },
  profile: {
    contactInformation: 'profile.contactInformation',
    password: 'profile.password',
  },
  notFound: {
    notFound: 'notFound.notFound',
  },
  noPermission: {
    noPermission: 'noPermission.noPermission',
  },
  snack: {
    severity: (severity: AlertProps['severity']) => `snack.${severity}`,
  },
  dashboard: {
    activeUsersChartTitle: 'dashboard.activeUsersChartTitle',
    averageSelectedDays: 'dashboard.averageSelectedDays',
    averagePreviousDays: 'dashboard.averagePreviousDays',
    selected: 'dashboard.selected',
    previous: 'dashboard.previous',
    downloads: 'dashboard.downloads',
    loggedIn: 'dashboard.loggedIn',
    withESim: 'dashboard.withESim',
    activeESimProfile: 'dashboard.activeESimProfile',
  },
  sessionEndDialog: {
    title: 'sessionEndDialog.title',
    message: 'sessionEndDialog.message',
    logOut: 'sessionEndDialog.logOut',
    refresh: 'sessionEndDialog.refresh',
  },
  login: {
    email: 'login.email',
    password: 'login.password',
    logIn: 'login.logIn',
    passwordLengthError: 'login.passwordLengthError',
  },
  passwordReset: {
    passwordReset: 'passwordReset.passwordReset',
    success: 'passwordReset.success',
    reset: 'passwordReset.reset',
    expired: 'passwordReset.expired',
  },
  emailVerification: {
    title: 'emailVerification.title',
    subTitle: 'emailVerification.subTitle',
    alreadyVerified: 'emailVerification.alreadyVerified',
    hasExpired: 'emailVerification.hasExpired',
    error: 'emailVerification.error',
  },
  payment: {
    backButton: 'payment.backButton',
    message: 'payment.message',
  },
  inputFieldsErrors: {
    isEmpty: 'inputFieldsErrors.isEmpty',
    passwordDoesNotMatch: 'inputFieldsErrors.passwordDoesNotMatch',
    passwordLengthError: 'inputFieldsErrors.passwordLengthError',
  },
  configs: {
    title: 'configs.title',
    timesToApplyACode: 'configs.timesToApplyACode',
    rewardType: 'configs.rewardType',
    freePlan: 'configs.freePlan',
    balance: 'configs.balance',
    rewardReceivers: 'configs.rewardReceivers',
    rewardThreshold: 'configs.rewardThreshold',
    paymentMethods: 'configs.paymentMethods',
  },
};

export default tPaths;
